import React from "react";
import Arrow from "../images/icon-arrow.svg";
import validator from "validator";
import tippy from "tippy.js";
import "tippy.js/themes/light.css";

const SearchBar = ({ searchResult }) => {
	const [searchInput, setSearchInput] = React.useState();
	const isIpAddress = new RegExp(/^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/);

	const newSearchResult = (event) => {
		return setSearchInput(event.target.value);
	};

	const sendSearchResult = () => {
		if (isIpAddress.test(searchInput) || validator.isURL(searchInput)) {
			document.getElementById("search-bar-container")._tippy?.destroy();
			return searchResult(searchInput);
		} else {
			return tippy("#search-bar-container", {
				content: "Please Enter A Valid IP Address or Domain Name",
				theme: "grey",
				showOnCreate: true,
				hideOnClick: false,
				arrow: false,
			})[0];
		}
	};

	return (
		<section id="search-bar-container" className="search-bar-div">
			<form className="search-bar">
				<input id="search-bar" onChange={newSearchResult} className="search-bar-input" placeholder="Search for any IP address or domain" />
				<button onClick={sendSearchResult} className="button" type="button">
					<img src={Arrow} alt="Click to submit!" />
				</button>
			</form>
		</section>
	);
};

export default SearchBar;
